import {
  NavigationMenuItem,
  NavigationMenuContent,
  NavigationMenuLink,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { InfoBlock } from "./InfoBlock";
import { FeatureBlock } from "./FeatureBlock";
import { FooterLinks } from "./FooterLinks";
import { SubMenuItems } from "./SubMenuItems";
import Link from "next/link";
import type { MenuItemType } from "@/types/menu";
import { cn } from "@/lib/utils";

// const splitPointForLongListMenu = 5;

export const MenuItem = ({ item, hoverBgName }: { item: MenuItemType, hoverBgName: string }) => {
  // const isFirstItem = item.label === "Partners"; // Debugging   

  if (item?.hasSubmenu && item?.subMenu) {
    return (
      <NavigationMenuItem key={item.label}> 
      {/* <NavigationMenuItem key={item.label} value={isFirstItem ? "debug-open" : ""}>  */}
        <NavigationMenuTrigger className={cn("text-foreground bg-transparent")} hoverBgName={hoverBgName}>{item.label}</NavigationMenuTrigger>
        <NavigationMenuContent className="bg-background dark:bg-muted p-0 !w-full">
          <div className="flex">
            <div className="flex flex-col flex-1 pr-8 pl-10 pt-10 pb-4">
              <div className="flex flex-1">
                {item.subMenu.hasInfoBlock && item.subMenu.infoBlock && (
                  <div className="w-[234px] mr-10">
                    <InfoBlock item={item.subMenu.infoBlock} />
                  </div>
                )}
                <div className={cn(
                  'flex-1 flex flex-row ',
                  (item.subMenu.rightColItems && item.subMenu.rightColItems.items && item.subMenu.rightColItems.items.length === 1 && 
                    item.subMenu.leftColItems && item.subMenu.leftColItems.items && item.subMenu.leftColItems.items.length === 1
                  ) ? 'gap-x-6' : 'gap-x-8'
                )}>
                  {item.subMenu.hasLeftColItems && item.subMenu.leftColItems?.items && item.subMenu.leftColItems.items.length > 0 && (
                    <div className={cn(
                      item.subMenu.rightColItems && item.subMenu.rightColReducedWidth ? 'flex-1' : 'w-[50%]'
                    )}>
                      <SubMenuItems items={item.subMenu.leftColItems} />
                    </div>
                  )}
                  {item.subMenu.rightColBorderBefore && (
                    <div className="border-l-1"></div>
                  )}
                  {item.subMenu.hasRightColItems && item.subMenu.rightColItems?.items && item.subMenu.rightColItems.items.length > 0 && (
                    <div className={cn(
                      item.subMenu.rightColItems && item.subMenu.rightColReducedWidth ? 'w-[20%]' : 'w-[50%]'
                    )}>
                      <SubMenuItems items={item.subMenu.rightColItems} />
                    </div>
                  )}
                </div>
              </div>
              {(item.subMenu.hasFooterMenuItems && item.subMenu.footerMenuItems && item.subMenu.footerMenuItems.length > 0) ? (
                <div className="mt-10 border-t-1">
                  <FooterLinks items={item.subMenu.footerMenuItems} />
                </div>
              ) : (
                <div className="pb-6"></div>
              )}
            </div>
            {item.subMenu.hasFeatureBlock && item.subMenu.featureBlock && (
              <div className="min-w-[300px] max-w-[480px] w-[20%] bg-muted dark:bg-background hidden 2xl:block">
                <FeatureBlock item={item.subMenu.featureBlock} />
              </div>
            )}
          </div>
          
        </NavigationMenuContent>
      </NavigationMenuItem>
    );
  }

  return (
    <NavigationMenuItem key={item.label}>
      <NavigationMenuLink asChild>
        <Link
          href={item.link || '#'}
          className="group/menuItem inline-flex h-10 w-max items-center justify-center !rounded-full bg-background px-4 py-2 !paragraph-base font-normal transition-colors hover:bg-muted hover:text-accent-foreground"
          prefetch={false}
        >
          {item.label}
        </Link>
      </NavigationMenuLink>
    </NavigationMenuItem>
  );
};

MenuItem.displayName = 'NavMenuItem'; 